"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _inject = require("../utils/inject");
var _createDeclarationBlock = _interopRequireDefault(require("../utils/create-declaration-block"));
var _hash = _interopRequireDefault(require("../hash"));
var _common = require("../utils/common");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const createStyleSheet = stylesWithQuery => {
  if (!stylesWithQuery) return {
    ids: {},
    styles: {},
    fullStyles: {}
  };
  let ids = {};
  const cleanStyles = (0, _common.deepClone)(stylesWithQuery);
  Object.keys(stylesWithQuery).forEach(key => {
    if (!stylesWithQuery?.[key]) return;
    const mediaQueriesAndPseudoClasses = Object.keys(stylesWithQuery[key]).filter(_common.isMediaOrPseudo);
    mediaQueriesAndPseudoClasses.forEach(query => {
      const sanitizedStyle = (0, _common.sanitizeStyle)(stylesWithQuery[key][query]);
      const css = (0, _createDeclarationBlock.default)(sanitizedStyle);
      const stringHash = `rnmq-${(0, _hash.default)(`${key}${query}${css}`)}`;
      const rule = (0, _common.createCssRule)(query, stringHash, css);
      (0, _inject.addCss)(`${stringHash}`, rule);
      delete cleanStyles[key][query];
      ids = {
        ...ids,
        [key]: `${ids?.[key] ? `${ids[key]} ` : ''}${stringHash}`
      };
    });
  });
  return {
    ids,
    styles: cleanStyles,
    fullStyles: stylesWithQuery
  };
};
var _default = exports.default = createStyleSheet;